import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
      setIsMobile(true); // Mobile screen size
    } else {
      setButton(true);
      setIsMobile(false); // Larger screen size
    }
  };

  useEffect(() => {
    showButton(); // Check screen size on initial render
    window.addEventListener('resize', showButton); // Add resize listener

    return () => {
      window.removeEventListener('resize', showButton); // Cleanup listener
    };
  }, []);

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
            Pharr Thrown
          </Link>

          {/* Display hamburger only on mobile screens */}
          {isMobile && (
            <div className='menu-icon' onClick={handleClick}>
              <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
            </div>
          )}

          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className='nav-item'>
              <Link to='/products' className='nav-links' onClick={closeMobileMenu}>
                Gallery
              </Link>
            </li>
            <li className='nav-item'>
              <Link to='/services' className='nav-links' onClick={closeMobileMenu}>
                Teaching
              </Link>
            </li>
            <li className='nav-item'>
              <Link to='/about' className='nav-links' onClick={closeMobileMenu}>
                About Wade
              </Link>
            </li>
            <li>
              <Link to='/sign-up' className='nav-links-mobile' onClick={closeMobileMenu}>
                Cart
              </Link>
            </li>
          </ul>

          {/* Show Cart Button only on larger screens */}
          {button && <Button buttonStyle='btn--outline'>Cart (0)</Button>}
        </div>
      </nav>
    </>
  );
}

export default Navbar;